import type { CartConfig } from '#types/config/components/cart'

export default {
  brandClasses: {
    details: 'text-sm',
    progress: 'rounded bg-green-30',
    threshold: 'text-sm fw-bold'
  }
} satisfies CartConfig['shippingProgress']
